/** Type predicates over native checks; no library dependency. */

/**
 * @param {unknown} value
 * @returns {value is Function}
 */
export function isFunction(value) {
  return typeof value === "function";
}

/**
 * @param {unknown} value
 * @returns {value is number}
 */
export function isNumber(value) {
  return typeof value === "number";
}

/**
 * A finite number; rejects Infinity, NaN, and numeric strings.
 * @param {unknown} value
 * @returns {value is number}
 */
export function isFiniteNumber(value) {
  return typeof value === "number" && Number.isFinite(value);
}

/**
 * @param {unknown} value
 * @returns {value is undefined}
 */
export function isUndefined(value) {
  return value === undefined;
}

/**
 * @param {unknown} value
 * @returns {value is (null | undefined)}
 */
export function isNil(value) {
  return value === undefined || value === null;
}

/**
 * @param {unknown} value
 * @returns {value is (null | undefined | "")}
 */
export function isBlank(value) {
  return isNil(value) || value === "";
}
